/**
 * Per-tenant feature flags, as served by GET /v3/FeatureFlags and cached by GlobalService.
 */

/**
 * Gates the whole VPOD Type concept. The literal is a contract with the backend and the Operations
 * app, so a spec pins it rather than trusting it to stay in step.
 *
 * The flag is not in the backend's declared-flag list, so it reaches the wire only via the
 * undeclared-flag superset and can be absent from the response entirely, which reads as OFF.
 */
export const FEATURE_VPOD_TYPE = 'FeatureVpodType';

/**
 * Whether a raw flag value means ON.
 *
 * The endpoint serves a string-to-object map, so a value arrives as whatever type its backing setting
 * has. A plain truthy check would be wrong in both directions: the strings 'Hide' and 'false' are
 * both truthy in JavaScript and both mean OFF.
 *
 * Only booleans and the strings 'show' / 'true' (any case) are ON. Everything else - a number, an
 * object, 'on', 'yes', or an absent value - is deliberately OFF: a gate should fail closed rather
 * than guess, and this mirrors the Operations app so the two cannot disagree about whether a tenant
 * has the feature.
 */
export function isFeatureFlagEnabled(value: unknown): boolean {
	if (typeof value === 'boolean') {
		return value;
	}
	if (typeof value === 'string') {
		const lower = value.toLowerCase();
		if (lower === 'show' || lower === 'true') {
			return true;
		}
	}
	return false;
}
